import * as React from 'react';
import PropTypes from 'prop-types';

function StartScreen(props) {
    return (
        <button
            className="btn btn-success btn-block my-2"
            onClick={ props.onSubmit }
        >
            Da-i drumul la joc
        </button>
    );
}

StartScreen.propTypes = {
    onSubmit: PropTypes.func.isRequired
};

export default StartScreen;



// WEBPACK FOOTER //
// ./src/components/StartScreen.js